
import Loading from 'vux/src/components/loading/index.vue'

export default {
components: {
Loading
},
props: {
title: String,
disabledText: String,
disabled: Boolean
}
}



// WEBPACK FOOTER //
// ./src/plugin/bottombtn.vue